import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatIcon } from '@angular/material/icon';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  templateUrl: './connect-outdated-dialog.component.html',
  styleUrls: ['./connect-outdated-dialog.component.scss'],
  imports: [FontAwesomeModule, MatIcon],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConnectOutdatedDialogComponent {
  public constructor(
    private readonly dialogRef: MatDialogRef<ConnectOutdatedDialogComponent>
  ) {}

  protected acceptNewConnection(): void {
    this.handleSubmitDialog({
      acceptNewConnect: true,
      acceptPrevConnect: false
    });
  }

  protected acceptPrevConnection(): void {
    this.handleSubmitDialog({
      acceptNewConnect: false,
      acceptPrevConnect: true
    });
  }

  protected closeDialog(): void {
    this.dialogRef.close();
  }

  private handleSubmitDialog({ acceptNewConnect, acceptPrevConnect }): void {
    this.dialogRef.close({
      acceptNewConnect: acceptNewConnect ?? false,
      acceptPrevConnect: acceptPrevConnect ?? false
    });
  }
}
